// Stable reasons the API reports in MyProject/MyLibrary.failure_code when
// curation_status is 'failure'. Keep in sync with the backend whitelist
// (src/lib/curation/curationFailureCode.js).
const FAILURE_MESSAGE_KEYS: Record<string, string> = {
  // The rundown PDF has no story in common with the video, e.g. two blocks
  // uploaded with their PDFs swapped.
  news_pdf_mismatch: 'projectEditor.newsPdfMismatch',
  // The uploaded video has no audio track, so it cannot be transcribed.
  source_no_audio: 'projectEditor.sourceNoAudio',
  // The video has no speech (e.g. a music video), or too little to pick clips
  // from, even after the worker retried with language auto-detection.
  transcript_empty: 'projectEditor.transcriptEmpty',
  transcript_too_sparse: 'projectEditor.transcriptTooSparse',
  // The explicit dub track chosen at import is no longer on the YouTube video.
  audio_track_unavailable: 'projectEditor.audioTrackUnavailable',
};

// i18n key of the message shown on a failed project/library page.
export function curationFailureMessageKey(failureCode?: string | null): string {
  return (failureCode && FAILURE_MESSAGE_KEYS[failureCode]) || 'projectEditor.errorProcessingProject';
}
